import CellSelectionDecorationPlugin from '@src/ui/Editor/plugins/cellSelectionDecorationPlugin';
import { Extension } from '@tiptap/core';

export const CellDecorationExtension = Extension.create({
  name: 'cellDecoration',
  addProseMirrorPlugins() {
    return [CellSelectionDecorationPlugin];
  },
});

export default CellDecorationExtension;
